import { useState } from "react";
import { Loader2, Mail, Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export const ContactForm = () => {
  const [f, setF] = useState({ name: "", email: "", company: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", f);
      setDone(true);
      toast.success("Message envoyé, nous vous répondrons vite.");
      setF({ name: "", email: "", company: "", message: "" });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="rounded-xl border border-sky-500/30 bg-sky-500/5 p-10 text-center" data-testid="contact-success">
        <Mail className="h-8 w-8 text-sky-400 mx-auto mb-4" />
        <h3 className="text-xl font-bold">Merci, votre message est parti.</h3>
        <p className="text-slate-400 text-sm mt-2">Nous revenons vers vous par email dès que possible.</p>
        <Button variant="secondary" className="mt-6 rounded-full" onClick={() => setDone(false)} data-testid="contact-again-btn">Envoyer un autre message</Button>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="rounded-xl border border-slate-800 bg-[#0B1120] p-8 space-y-4" data-testid="contact-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <Input required placeholder="Votre nom" value={f.name} onChange={set("name")} className="bg-[#0F172A] border-slate-700" data-testid="contact-name" />
        <Input required type="email" placeholder="Votre email" value={f.email} onChange={set("email")} className="bg-[#0F172A] border-slate-700" data-testid="contact-email" />
      </div>
      <Input placeholder="Société (facultatif)" value={f.company} onChange={set("company")} className="bg-[#0F172A] border-slate-700" data-testid="contact-company" />
      <Textarea required placeholder="Votre message" value={f.message} onChange={set("message")} className="bg-[#0F172A] border-slate-700 h-32" data-testid="contact-message" />
      <Button type="submit" size="lg" disabled={busy} className="rounded-full w-full sm:w-auto px-8" data-testid="contact-submit">
        {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Send className="h-4 w-4 mr-2" />} Envoyer le message
      </Button>
    </form>
  );
};
